import { ErrorIconV2 } from "../Icons";
import { Typo } from "../Typo";

type Props = {
  kind: "table" | "chart" | "page";
  errorTitle: string;
  errorText: string;
  errorActionText: string;
  action?: () => Promise<void> | void;
};

export const ApiError = ({
  kind,
  errorTitle,
  errorText,
  errorActionText,
  action,
}: Props) => {
  return (
    <div
      className={`flex w-full flex-col items-center justify-center ${
        kind === "chart" ? "gap-4" : "gap-6"
      } pr-0`}
      data-testid={`api-error-${kind}`}
    >
      {kind !== "chart" && <ErrorIconV2 width={64} height={64} />}
      <div
        className={`flex flex-col items-center ${kind === "chart" ? "gap-4" : "gap-6"} w-2/4 text-center`}
      >
        <Typo element="span" type="labelLG" classes="whitespace-nowrap">
          {errorTitle}
        </Typo>
        <Typo
          element="span"
          type="bodyMD"
          textColor="text-text-secondary"
          classes="whitespace-nowrap"
        >
          {errorText}
        </Typo>
      </div>
      <button
        onClick={() => action?.()}
        type="button"
        className="h-12 min-w-24 rounded-lg bg-surface-brand-default px-4 py-3 text-sm"
      >
        <Typo type="labelSM" textColor="text-text-inverse-primary">
          {errorActionText}
        </Typo>
      </button>
    </div>
  );
};
